import { useEffect, useState } from "react";
import "./item.css";

function Item({
  item,
  deleteFun,
  handleCheck,
  itemsList,
  updateFun,
  dispatch,
}) {
  return (
    <div className="item">
      <li>
        <input
          type="checkbox"
          onClick={() => {
            handleCheck(item.id);
            let test = item.status === "Done" ? true : false;
          }}
          value={item.status === "Done" ? false : true}
          checked={item.status === "Done" ? true : false}
        />
        <p
          style={
            item.status === "Done" ? { textDecoration: "line-through" } : {}
          }
          className={item.oneTask.length >= 12 ? "task" : "task-mini"}
        >
          {item.oneTask}
        </p>
        <span className="task-status">{item.status}</span>
        <button className="delete-btn" onClick={() => deleteFun(item.id)}>
          ❌
        </button>
        <button className="edit-btn" onClick={() => updateFun(item.id)}>
          ✏️
        </button>
      </li>
    </div>
  );
}

export default Item;
